import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getIsLineBeingSaved } from 'store/dealManagement/selectors';

import { useDealManagement } from 'store/dealManagement/useDealManagement';
import { useCpmCampaignLevel } from 'components/pages/DealWithLines/useCpmCampaignLevel';

import { PageWrapper } from 'components/common/layout/PageWrapper/PageWrapper';
import Preloader from 'lib/Preloader';
import { useDynamicTabName } from 'customHooks/useDynamicTabName';
import { useCancelRequest } from 'customHooks/useCancelRequest';
import DealLines from './DealLines';

const DealWithLines = () => {
  const { internalId } = useParams();

  const { isEditingDisabled, isLoading, isFetchingAllocation } = useDealManagement({ isNewDeal: !internalId });
  useCpmCampaignLevel();
  useDynamicTabName();
  useCancelRequest();

  const isLineBeingSaved = useSelector(getIsLineBeingSaved);

  return (
    <PageWrapper>
      <DealLines />
      <Preloader isLoading={isLineBeingSaved || isEditingDisabled || isLoading || isFetchingAllocation} />
    </PageWrapper>
  );
};

export default DealWithLines;
